export const CRAFTERHACK_DARK_THEME = "crafterhack-dark";
export const CRAFTERHACK_LIGHT_THEME = "crafterhack-light";

export const CRAFTERHACK_EDITOR_FONT_FAMILY =
  "Menlo, Monaco, 'Courier New', ui-monospace, SFMono-Regular, Consolas, 'Liberation Mono', monospace";

let themesRegistered = false;

export function defineCrafterhackThemes(monaco) {
  if (themesRegistered) return;
  themesRegistered = true;

  monaco.editor.defineTheme(CRAFTERHACK_DARK_THEME, {
    base: "vs-dark",
    inherit: true,
    rules: [
      { token: "comment", foreground: "6A9955", fontStyle: "italic" },
      { token: "keyword", foreground: "569CD6" },
      { token: "string", foreground: "CE9178" },
      { token: "number", foreground: "B5CEA8" },
      { token: "type", foreground: "4EC9B0" },
      { token: "function", foreground: "DCDCAA" },
      { token: "variable", foreground: "9CDCFE" },
      { token: "identifier", foreground: "D4D4D4" },
      { token: "delimiter", foreground: "D4D4D4" },
    ],
    colors: {
      "editor.background": "#1a1a1a",
      "editor.foreground": "#eeeff1",
      "editorLineNumber.foreground": "#3c3c43",
      "editorLineNumber.activeForeground": "#e5e5e6",
      "editor.lineHighlightBackground": "#232323",
      "editor.lineHighlightBorder": "#232323",
      "editor.selectionBackground": "#264f78",
      "editor.inactiveSelectionBackground": "#264f7880",
      "editor.selectionHighlightBackground": "#add6ff26",
      "editorCursor.foreground": "#ffffff",
      "editorIndentGuide.background": "#2b2b2b",
      "editorIndentGuide.activeBackground": "#4d4d4d",
      "editorWhitespace.foreground": "#3b3b3b",
      "editorGutter.background": "#1a1a1a",
      "editorBracketMatch.background": "#3a3d4130",
      "editorBracketMatch.border": "#585858",
      "scrollbarSlider.background": "#4d4d4d4d",
      "scrollbarSlider.hoverBackground": "#5c5c5c66",
      "scrollbarSlider.activeBackground": "#6b6b6b80",
    },
  });

  monaco.editor.defineTheme(CRAFTERHACK_LIGHT_THEME, {
    base: "vs",
    inherit: true,
    rules: [
      { token: "comment", foreground: "008000", fontStyle: "italic" },
      { token: "keyword", foreground: "0000ff" },
      { token: "string", foreground: "a31515" },
      { token: "number", foreground: "098658" },
      { token: "type", foreground: "267f99" },
      { token: "function", foreground: "795e26" },
    ],
    colors: {
      "editor.background": "#ffffff",
      "editor.foreground": "#262626",
      "editorLineNumber.foreground": "#a0a0a0",
      "editorLineNumber.activeForeground": "#3c3c3c",
      "editor.lineHighlightBackground": "#f5f5f5",
      "editor.selectionBackground": "#add6ff",
      "editorCursor.foreground": "#000000",
      "editorIndentGuide.background": "#e3e3e3",
      "editorIndentGuide.activeBackground": "#c7c7c7",
    },
  });
}

export function getCrafterhackEditorOptions(fontSize = 14) {
  return {
    fontFamily: CRAFTERHACK_EDITOR_FONT_FAMILY,
    fontLigatures: false,
    fontSize,
    lineHeight: Math.round(fontSize * 1.5),
    letterSpacing: 0.2,
    cursorBlinking: "smooth",
    cursorStyle: "line",
    cursorWidth: 2,
    cursorSmoothCaretAnimation: "on",
    smoothScrolling: true,
    renderLineHighlight: "all",
    minimap: { enabled: false },
    padding: { top: 12, bottom: 12 },
    bracketPairColorization: { enabled: true },
    guides: { indentation: true, bracketPairs: false },
    scrollBeyondLastLine: false,
    automaticLayout: true,
    tabSize: 4,
    renderWhitespace: "selection",
    scrollbar: {
      verticalScrollbarSize: 10,
      horizontalScrollbarSize: 10,
      useShadows: false,
    },
    // Native EditContext-based text input — the legacy DOM textarea path
    // (editContext:false) drops keystrokes under fast typing when combined
    // with frequent re-renders, which is exactly what this app's editors do.
    editContext: true,
  };
}
